import { Checkbox } from "@shopify/polaris";
import React from "react";
import { arrInvalid } from "../../helper";
import { ELEMENTS, initNewField } from "./Customize";

export default function FillAllCustomField({
    personalized,
    hasFieldValue,
    isAmazon,
    setState,
}) {
    const [isFill, setIsFill] = React.useState(false);

    const [fields, metaValue] = genFields(
        personalized,
        hasFieldValue,
        isAmazon,
    );

    const handleChange = React.useCallback(
        (newValue) => {
            setIsFill(newValue);

            if (newValue) {
                setState({
                    metaValue,
                    fields,
                });
            } else {
                setState({
                    metaValue: undefined,
                    fields: [],
                });
            }
        },
        [fields, metaValue],
    );

    return (
        <>
            <Checkbox
                label="Fill All Custom Fields"
                checked={isFill}
                onChange={handleChange}
            />
        </>
    );
}

function genFields(personalized, hasFieldValue, isAmazon) {
    if (arrInvalid(personalized)) return [];

    const res = [];

    const metaValue = {};
    for (let i = 0; i < personalized.length; i++) {
        const { name, value } = personalized[i] || {};
        if (!name || !value) continue;

        const element = ELEMENTS[0];
        const newValue = initNewField(element, i + 1);

        if (
            newValue &&
            newValue.configure &&
            newValue.configure.required != null
        ) {
            newValue.configure.required = false;
        }
        if (hasFieldValue) {
            newValue["fieldValue"] = {};
            newValue["title"] = name;
            if (isAmazon) {
                newValue["fieldValue"] = {
                    key: name,
                    customValue: false,
                    value,
                };

                metaValue[i] = name;
            }
        }
        res.push(newValue);
    }

    return [res, metaValue];
}
